import React from 'react';
import StaticInspForm from 'components/FieldTests/StaticInspForm';
import ButtonLink from 'components/Shared/ButtonLink';
import Drawer from '@material-ui/core/Drawer';

const withInspectionLink = (WrappedComponent, { inspectionColumnTitle }) => {
    return class WithInspectionLink extends React.Component {
        tableRef = React.createRef();
        
        constructor(props) {
            super(props);
            this.state = {
                showDialog: false,
                inspectionNumber: undefined
            }

            if(props.tableRef) {
                this.tableRef = props.tableRef;
            };
        }

        setShowDialog = (e) => { this.setState({ showDialog: e }) };
        setInspNumber = (num) => { this.setState({ inspectionNumber: num }) };

        setShowApproveDialog = (e) => { this.setState({ showApproveDialog: e }) };

        handleInspClick = (event) => {
            event.stopPropagation();
            this.setShowDialog(true);
            const inspNumber = event.target.valueOf().innerText;
            this.setInspNumber(inspNumber)
        };

        columns = this.props.columns.map(col => {
            if (col.title === inspectionColumnTitle) {
                col.render = (rowData) => (<ButtonLink onClick={this.handleInspClick}>{rowData[col.field]}</ButtonLink>)
            }
            return col;
        })

        render() {
            return (
                <>
                    <WrappedComponent tableRef={this.tableRef} {...this.props} {...{ columns: this.columns }} />
                    <Drawer anchor="right" open={this.state.showDialog} onClose={() => { this.setState({ showDialog: false, inspNumber: undefined }); }}>
                        <div style={{ width: "25vw", minWidth: 200 }}>
                        {this.state.inspectionNumber && <StaticInspForm inspectionNumber={this.state.inspectionNumber} />}
                        </div>
                    </Drawer>
                    
                </>
            )
        }
    }
}

export default withInspectionLink;